module.exports = __webpack_public_path__ + "img/set-up-profile.df6c56b2.jpg";